<template>
  <div class="mydevice-bd">
    <div class="product-wrap">
      <el-radio-group v-model="tabActive" class="radio-group">
        <el-radio-button :label="item.value" v-for="(item, index) in tabType" :key="index">{{ item.label }}</el-radio-button>
      </el-radio-group>
      <!--统计 -->
      <template v-if="tabActive === 1">
        <div class="count-box">
          <div class="titel"></div>
          <div class="chart-coontract" ref="pie"></div>
        </div>
      </template>
      <template v-if="tabActive === 2">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>

            <el-form-item style="float: right">
              <search-input v-model="formSearch.search" :placeholder="$t('crm_partner-device.jshModemSNsbmc')" @fetch="onPageChange({ page: 1 })"></search-input>
            </el-form-item>
            <el-form-item style="float: right">
              <switch-button :link="$refs.container"></switch-button>
            </el-form-item>
          </el-form>
        </div>
        <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
          <el-form :inline="true" label-position="top">
            <!-- 产品型号 -->
            <el-form-item :label="$t('crm_partner-device.chan_pin_xing_hao')">
              <custom-select
                url="productCodeSelectList"
                v-model="formSearch.productCode"
                :props="{ label: 'productCode', value: 'productCode' }"
                :placeholder="$t('Common.com_please_select')"
                width="100%"
              ></custom-select>
            </el-form-item>
            <!-- 最后在线时间 -->
            <el-form-item :label="$t('crm_partner-device.qi_zu_shi_jian')">
              <custom-date-picker
                v-model="formSearch.rentTime"
                type="datetimerange"
                align="right"
                value-format="YYYY-MM-DD HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptionDisAfter"
                 unlink-panels
                range-separator="——"
                start-placeholder=""
                end-placeholder=""
                 style="width: 100%"
              ></custom-date-picker>

            </el-form-item>
            <!-- 最后清洁时间 -->
            <el-form-item :label="$t('crm_partner-device.dao_qi_shi_jian')">
              <custom-date-picker
                v-model="formSearch.expireTime"
                type="datetimerange"
                align="right"
                value-format="YYYY-MM-DD HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptionDisAfter"
                unlink-panels
                range-separator="——"
                start-placeholder=""
                end-placeholder=""
                style="width: 100%"
              ></custom-date-picker>
            </el-form-item>

            <!-- 合同编号 -->
            <el-form-item :label="$t('crm_partner-device.he_tong_bian_hao')">
              <el-input v-model="formSearch.contractNo" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
            <!-- 订单编号-->
            <el-form-item :label="$t('crm_partner-device.ding_dan_bian_hao')">
              <el-input v-model="formSearch.orderCode" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="$t('crm_partner-device.shou_hou_gong_si')">
              <el-input v-model="formSearch.scOrgName" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="$t('crm_partner-device.dai_li_gong_si')">
              <el-input v-model="formSearch.jvOrgName" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="$t('crm_partner-device.zu_lin_fang')">
              <el-input v-model="formSearch.csOrgName" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="$t('crm_partner-device.ji_tuan_ke_hu')">
              <el-input v-model="formSearch.bigCsOrgName" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item :label="$t('crm_partner-device.xiang_mu_ming_cheng')">
              <el-input v-model="formSearch.locationName" placeholder="" style="width: 100%"></el-input>
            </el-form-item>
          </el-form>
        </switch-container>
        <div class="table-bd">
          <custom-table
            tableCode="my_biz_device"
            :data="deviceList"
            :index="true"
            @filter="filterChange"
            @sort="sortChange"
            height="100%"
            :filterArr="['action']"
            :slots="['bodyNum', 'action', 'contractNo']"
          >
            <!-- 'isOnline','activateState','siteName','timezone','gpsAddress','lockState' -->
            <template v-slot:bodyNum="scope">
              <div class="cell-link" @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.fullPath  })">{{ scope.row.bodyNum }}</div>
            </template>
            <template v-slot:contractNo="scope">
              <div class="cell-link" @click="jump('/contractdetail', { contractId: scope.row.orderId, contractClass: scope.row.orderType2, parentPath: $route.fullPath })">
                {{ scope.row.contractNo }}
              </div>
            </template>
            <!-- </el-table-column> -->
          </custom-table>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import G2 from 'G2';
import DataSet from '@antv/data-set';
import insertCss from 'insert-css';
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

insertCss(`
    .pie-guide-html {
        width: 100px;
        height: 80px;
        vertical-align: middle;
        text-align: center;
        line-height: 0.2;
    }

    .pie-guide-html .title {
        font-size: 12px;
        color: #8c8c8c;
        font-weight: 300;
    }

    .pie-guide-html .value {
        font-size: 12px;
        color: #000;
        font-weight: bold;
        padding-left: 10px;
    }
`);
export default {
  mixins: [resetFormSearchMixins],
  props: ['partnerOrgId'],
  components: {
  },
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        // stockInState: 2,
        partnerOrgId: '',

        productCode: '',
        rentTime: '',
        rentStartTime: '', // 启租开始时间
        rentEndTime: '', // 启租结束时间
        expireTime: '',
        expireStartTime: '', // 到期开始时间
        expireEndTime: '', // 到期结束时间
        contractNo: '',
        orderCode: '',
        scOrgName: '',
        jvOrgName: '',
        csOrgName: '',
        bigCsOrgName: '',
        locationName: '',
      },

      deviceList: [],
      totalRows: null,
      deviceBizCount: [],

      tabActive: 2,
      dms_device_biz_state: {}
    };
  },
  computed: {
    tabType() {
      return [
        {
          label: this.$t('crm_partner-device.tong_ji'),
          value: 1,
        },
        {
          label: this.$t('crm_partner-device.lie_biao'),
          value: 2,
        },
      ];
    }
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    // this.getTableColumn();
    this.getFuncView();
    this.getDeviceList();

    this.getDictionary('dms_device_biz_state', (data) => {
      this.dms_device_biz_state = this.$transformDicValue(data.dms_device_biz_state);
    });
    // this.getDeviceBizCount();
  },
  watch: {
    tabActive: {
      // 深度监听，可监听到对象、数组的变化
      handler(val) {
        if (val === 1) {
          // 获取合同统计
          this.getDeviceBizCount();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 获取我的设备列表
    getDeviceList: function () {
      this.isLoading = true;
      this.formSearch.rentStartTime = this.formSearch.rentTime && this.formSearch.rentTime[0] ? this.formSearch.rentTime[0] : undefined;
      this.formSearch.rentEndTime = this.formSearch.rentTime && this.formSearch.rentTime[1] ? this.formSearch.rentTime[1] : undefined;
      this.formSearch.expireStartTime = this.formSearch.expireTime && this.formSearch.expireTime[0] ? this.formSearch.expireTime[0] : undefined;
      this.formSearch.expireEndTime = this.formSearch.expireTime && this.formSearch.expireTime[1] ? this.formSearch.expireTime[1] : undefined;
      this.formSearch.partnerOrgId = this.partnerOrgId;
      this.$getJSON(apis.MyDeviceBizPage, this.formSearch).then((res) => {
        if (res.code === 0) {
          this.isLoading = false;
          const list = res.data.list;
          this.deviceList = list;
          this.totalRows = res.data.total;
        }
      });
    },
    getDeviceBizCount: function () {
      this.$getJSON(`${apis.deviceBizCountBizType}/${this.partnerOrgId}`).then((res) => {
        this.deviceBizCount = res.data || [];
        this.drawPie();
      });
    },
    // 饼图
    drawPie() {
      const data = this.deviceBizCount.map((i) => {
        const obj = { ...i };
        const name = this.dms_device_biz_state[i.state] || '';
        obj.type = `${name} ${i.num} (${i.percent})`;
        return obj;
      });

      // const sum = this.deviceBizCount.reduce((total, item) => total + Number(item.num || 0), 0);
      const ds = new DataSet();
      const dv = ds.createView().source(data);

      const chart = new G2.Chart({
        container: this.$refs.pie,
        forceFit: true,
        height: 500,
        // width: 300,
        padding: 'auto',
      });
      chart.source(dv);
      chart.tooltip(false);
      chart.legend({
        position: 'right-center',
        offsetX: -200,
        offsetY: 10,
        itemMarginBottom: 20,
      });
      chart.coord('theta', {
        radius: 0.75,
        innerRadius: 0.73,
      });
      chart
        .intervalStack()
        .position('num')
        .color('type', ['rgba(0, 146, 225, 0.85)', 'rgba(46, 199, 201, 0.85)', 'rgba(178,212,59, 0.85)', 'rgba(253,206,64, 0.85)', 'rgba(0,174,239, 0.85)', 'rgba(104,124,242, 0.85)', 'rgba(86,70,236, 0.85)'])
        .opacity(1)
        .style({
          stroke: 'white',
          lineWidth: 1,
        })
        .label('num', {
          offset: -18,
          textStyle: {
            fill: 'white',
            fontSize: 12,
            shadowBlur: 2,
            shadowColor: 'rgba(0, 0, 0, .45)',
          },
          rotate: 0,
          autoRotate: false,
          formatter: () => '',


        });
      // chart.guide();
      // chart.guide().html({
      //   position: ['86%', '25%'],
      //   html: `<div class="pie-guide-html"><span class="title">${this.i18n.com_all}</span><span class="value">${sum}</span></div>`,
      // });

      chart.render();
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
  },
};
</script>

<style lang="scss">
.mydevice-bd {
  height: 100%;
  display: flex;
  flex-direction: column;
  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 220px;
    display: flex;
    .g2-p1 {
      width: 500px;
      height: 220px;
    }
    .g2-p2 {
      width: 460px;
      height: 200px;
      .g2-legend {
        height: 120px !important;
        width: 800px !important;
        max-width: 800px !important;
      }
      .g2-legend-list {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 100%;
      }
      .g2-legend-list-item {
        width: 120px;
      }
    }
  }
  .product-wrap {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    background-color: #ffffff;


    .radio-group {
      padding-top: 16px;
      padding-bottom: 14px;
      overflow: hidden;
    }
.count-box {
      height: 100%;
      width: 100%;
      background: #fff;
      position: relative;
      .chart-pie {
        overflow: hidden;
        position: relative;
        left: -68px;
        top: 48px;
      }
    }

  }
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
